import { useInternationalization } from "@progress/kendo-react-intl";
import { useEffect, useState } from "react";
import { sumByProperty } from "../../../utilities/objectUtilities";
import { IDetailItem } from "../../utilities/DetailItem";
import { QuoteDetailsSubHeader } from "../quoteDetails";

interface IVanillaPaymentSummary {
  details: any;
  decimals: number;
  isLong: boolean;
  totalVolume: number;
  unit: string;
}

export const VanillaPaymentSummary = ({
  details,
  decimals,
  isLong,
  totalVolume,
  unit,
}: IVanillaPaymentSummary) => {
  const formatter = useInternationalization();
  const [paymentSummary, setPaymentSummary] = useState<IDetailItem[]>([]);

  useEffect(() => {
    if (!details) return;

    const {
      quote: { buyerName, brokerName, sellerName, transactionDetails },
    } = details;
    const format = `c${decimals}`;

    const formatPrice = (value: number, unit: string, format: string) =>
      `${formatter.formatNumber(value, format)} / ${unit}`;

    const payments = [
      sumByProperty(transactionDetails, "fairValuePrice") / totalVolume,
      sumByProperty(transactionDetails, "riskTakerPrice") / totalVolume,
      sumByProperty(transactionDetails, "brokerPrice") / totalVolume,
    ].sort((a, b) => (isLong ? a - b : b - a));

    const items = [];
    if (sellerName.toLowerCase() !== "no seller name")
      items.push({ label: sellerName, content: formatPrice(payments[0], unit, format) });

    if (brokerName.toLowerCase() !== "no broker name")
      items.push({ label: brokerName, content: formatPrice(payments[1], unit, format) });

    if (buyerName.toLowerCase() !== "no buyer name")
      items.push({ label: buyerName, content: formatPrice(payments[2], unit, format) });

    const payer = items[items.length - 1];

    items.push({
      label: "Payment",
      content: `${payer.label} (${isLong ? "Long" : "Short"})`,
    });

    setPaymentSummary(items);
  }, [details]);

  return (
    <QuoteDetailsSubHeader details={paymentSummary} />
  );
};
